function* uidGenerator(base: number = 1): any {
  while (base) {
    yield `uid_${new Date().getTime()}_${base++}`;
  }
}

export const getUID = (generator => {
  return () => generator.next().value;
})(uidGenerator());
